import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const WoodmenLifeCompanyStoreIcon: React.FC<WLIconProps> = ({
  variant,
  ...rest
}) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc id="svgdescWLCompanyStore">shopping bag with WoodmenLife Logo</desc>
      <circle cx="100" cy="100" r="84.3" className="background" />
      <path
        d="M139.8 69.6a6 6 0 0 0-5.8-6h-11.4c-3-16.1-11.7-27-22.5-27-10.7 0-19.5 11.1-22.6 27H66.2a6 6 0 0 0-6 6l-8.6 67.3c0 3.2 3.5 8 6.8 8h83.2c3.3 0 6.8-4.7 6.8-8Zm-58.7-6A44.6 44.6 0 0 1 86.6 49c3.8-6 8.5-9.3 13.5-9.3 8.9 0 16.3 9.8 19 24Z"
        className="accent"
      />
      <path
        d="M74.2 72.2a3.6 3.6 0 1 1 3.6 3.6 3.6 3.6 0 0 1-3.6-3.6Zm48.2 3.6a3.6 3.6 0 1 1 3.5-3.6 3.6 3.6 0 0 1-3.5 3.6Zm-37.9 40.1v11.6a26.7 26.7 0 0 0 4.6 2.8v-17l-4.6 1.7Zm7.8-9.8-7.8 2.7v3.5l7.8-2.7v-3.5zM81.4 117v-1l-4.6 1.6a25.6 25.6 0 0 0 4.6 7Zm15.5-6.4-4.6 1.7v19.2a25.4 25.4 0 0 0 4.6 1Zm-15.5-.6-6.4 2a25.4 25.4 0 0 0 .8 3.2l5.6-2Zm29.4 20.3a25.7 25.7 0 0 0 4.7-2.8V115l-4.7-1.6Zm-3.1-20.7v-3.5l-7.7-2.7-4.6 1.6v3.5l4.6-1.6 7.7 2.7zM100 93l24.8 8.7a25.4 25.4 0 0 0-49.6 0Zm10.8 14.2v3.5l13.3 4.6a24.8 24.8 0 0 0 .9-3.2Zm-3 5-4.7-1.6v22a25.4 25.4 0 0 0 4.7-1Zm10.8 12.4a25.8 25.8 0 0 0 4.6-7l-4.6-1.6Z"
        className="background"
        style={{
          fill: variant === 'darkIconNoBackground' ? 'white' : undefined,
        }}
      />
    </Icon>
  );
};

export default WoodmenLifeCompanyStoreIcon;
